import React from 'react';
import styled from 'styled-components/macro';
import { Slider } from 'src/client/components/ui/Slider';

type Teaser = {
  galleryUUID: string;
  imgSrc: string;
  models: string[];
  name: string;
};

type Props = {
  className?: string;
  hideSlider: () => void;
  settings: Record<string, unknown>;
  teasers: Teaser[];
};

export const NormalSlider = (props: Props) => {
  const { className = '', settings, teasers, hideSlider } = props;

  const renderedSlides = teasers.map((teaser) => {
    const { name, models, galleryUUID, imgSrc } = teaser;
    const modelLabel = models.length ? models.join(' and ') : '';

    return (
      <div key={galleryUUID}>
        <TitleWrap>
          {name && <TitleText>{name}</TitleText>}
          <TitleModels>{modelLabel}</TitleModels>
          <MobileTitle>{`${name} - ${modelLabel}`}</MobileTitle>
        </TitleWrap>
        <Hero style={{ backgroundImage: `url(${imgSrc})` }} />
      </div>
    );
  });

  return (
    <>
      <SliderWrap className={`${className} slider-wrap`}>
        <Slider settings={settings} className="slider">
          {renderedSlides}
        </Slider>
      </SliderWrap>
      <HideButton type="button" onClick={hideSlider} className="hide-btn btn btn-primary">
        Watch Full Movie for Free
      </HideButton>
    </>
  );
};

const SliderWrap = styled.div`
  position: relative;
  height: 585px;
  background: #181818;
  z-index: 2;
  margin: 0 auto;
  padding: 0;
  width: 100%;

  @media (max-width: 768px) {
    width: 100vw;
    height: 200px;
    position: relative;
  }

  .slider {
    position: relative;
    display: block;
    height: 100%;
    padding: 0 !important;

    &:hover .slick-arrow {
      opacity: 1;
      pointer-events: auto;
    }
  }

  .slick-slider,
  .slick-track,
  .slick-list {
    height: 100%;
  }

  .slick-track {
    margin: 0;
  }

  .slick-arrow {
    position: absolute;
    display: block;
    top: 50%;
    transform: translateY(-50%);
    width: 50px;
    height: 70px;
    border: 0 none;
    border-radius: 4px;
    background-color: #1c1c1c;
    color: transparent;
    transition: 0.5s opacity ease;
    opacity: 0;
    pointer-events: none;
    z-index: 3;

    :hover {
      background-color: #000000;
    }
  }

  .slick-prev {
    left: 15px;
  }

  .slick-next {
    right: 15px;
  }

  .slick-dots {
    list-style: none;
    display: flex !important;
    position: absolute;
    bottom: 16px;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 0;

    @media (max-width: 768px) {
      display: none !important;
    }

    li {
      position: relative;
      display: inline-block;
      height: 20px;
      width: 20px;
      margin: 0 10px;
      padding: 0;
      cursor: pointer;
      background: white;
      border-radius: 50%;
      cursor: pointer;
      opacity: 0.25;
    }

    li.slick-active {
      opacity: 0.75;
    }

    button {
      color: transparent;
      background: transparent;
      border: 0;
      outline: none;
    }
  }

  & + .hide-btn {
    background: ${(props) => props.theme.primaryBtn1Bg};
    color: ${(props) => props.theme.primaryBtn1Text};
    :hover {
      background: ${(props) => props.theme.primaryBtn1HoverBg};
    }
    display: block;
    position: absolute;
    width: 270px;
    height: 52px;
    border: 0;
    border-radius: 3px;
    font-size: 1.15rem;
    top: auto;
    bottom: 200px;
    left: 100px;
    outline: none;
    z-index: 2;

    @media (max-width: 768px) {
      left: 0;
      width: 100vw;
      bottom: 0;
      font-size: 0.85rem;
      height: 30px;
    }
  }
`;

const TitleWrap = styled.div`
  position: absolute;
  color: #ffffff;
  left: 10px;
  top: auto;
  bottom: 280px;
  width: 450px;
  text-align: center;

  @media (max-width: 768px) {
    width: 100vw;
    left: 0;
    color: ${(props) => props.theme.primaryBtn1Text};
    background-color: rgba(0, 0, 0, 0.36);
    bottom: 30px;
  }
`;

const TitleText = styled.h1`
  text-transform: uppercase;
  font-weight: 400;
  font-size: 3rem;

  @media (max-width: 768px) {
    display: none;
  }
`;

const TitleModels = styled.span`
  @media (max-width: 768px) {
    display: none;
  }
`;

const MobileTitle = styled.span`
  display: none;

  @media (max-width: 768px) {
    display: inline-block;
    font-size: 0.85rem;
    line-height: 34px;
  }
`;

const Hero = styled.div`
  height: 585px;
  background-size: cover;

  @media (max-width: 768px) {
    height: 173px;
    width: 100vw;
    background-size: contain;
    background-repeat: no-repeat;
  }
`;

const HideButton = styled.button`
  display: block;
`;
